import "./FileNumberPill.scss";

import type { MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

type FileNumberPillProps = {
  fileId: number;
};

const FileNumberPill = ({ fileId }: FileNumberPillProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const url = `/operations/files/${fileId}/edit/claimant-information`;
    navigate(url);
  };

  const handleContextMenu = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    const url = `/operations/files/${fileId}/edit/claimant-information`;
    window.open(url, "_blank");
  };

  return (
    <div
      className="file-number-pill"
      onClick={handleClick}
      onContextMenu={handleContextMenu}
    >
      {fileId}
    </div>
  );
};

export default FileNumberPill;
